module.exports = __webpack_public_path__ + "bg.bfa5f643.svg";